module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"header":"When","description":"...this occurs, start my automation."}}')
  delete Component.options._Ctor
}
